import { FileUploadWithModal } from '@/components/organisms'
import { Constants } from '@/utils/constants/commonConstants'
import { useIntl } from 'react-intl'


export const TierFileUploadModal = ({ isVisible, setIsVisible, onDismiss, setFormData, formData }) => {

    const { formatMessage } = useIntl()

    return (
        <FileUploadWithModal
            openUpload={isVisible}
            setOpenUpload={setIsVisible}
            onClickSecondaryButton={onDismiss}
            onCloseModal={onDismiss}
            formData={formData}
            setFormData={setFormData}
            title={formatMessage({ id: 'CLUB_PLUS.TIER_FILE_UPLOAD_MODAL_DIALOG_TITLE' })}
            label={formatMessage({ id: 'CLUB_PLUS.TIER_FILE_UPLOAD_MODAL_DIALOG_LABEL' })}
            uploadFor={Constants.RewardsTierStoreUpload}
            isCsvValidationRequired={true}
        />
    )
}
